const MarketingModule = () => import('@/pages/marketing/MarketingModule.vue');
const MarketingInvitations = () => import('@/pages/marketing/subpages/MarketingInvitations.vue');
const MarketingMessage = () => import('@/pages/marketing/subpages/MarketingMessage.vue');
const MarketingManagingContent = () => import('@/pages/marketing/subpages/MarketingManagingContent.vue');
const ManagingContent = () => import('@/pages/marketing/subpages/ManagingContent.vue');
const MarketingManagingContentAddEdit = () => import('@/pages/marketing/subpages/MarketingManagingContentAddEdit.vue');
const CampaignUrl = () => import('@/pages/marketing/subpages/CampaignUrl.vue');
const CouponsConfig = () => import ('@/pages/marketing/subpages/CouponsConfig.vue');
const CampaignUrlCreateEdit = () => import('@/pages/marketing/subpages/CampaignUrlCreateEdit.vue');
const Webinars = () => import('@/pages/marketing/subpages/Webinars.vue');
const MarketingWebinars = () => import('@/pages/marketing/subpages/MarketingWebinars.vue');
const WebinarForm = () => import('@/pages/marketing/subpages/WebinarForm.vue');
const WebinarReport = () => import('@/pages/marketing/subpages/WebinarReport.vue');
const PartnerCards = () => import('@/pages/marketing/subpages/PartnerCards.vue');
const SinoaPartners = () => import('@/pages/marketing/subpages/SinoaPartners.vue');

const routes = [
  {
    path: '/marketing_module/',
    name: 'MarketingModule',
    meta: {
      title: 'Marketing Module',
    },
    component: MarketingModule,
    children: [
      {
        path: 'invitations/',
        component: MarketingInvitations,
      },
      {
        path: 'marketing_message/',
        component: MarketingMessage,
      },
      {
        path: 'managing_content/',
        meta: {
          title: 'Managing Content',
        },
        component: ManagingContent,
        children: [
          {
            path: '',
            component: MarketingManagingContent,
            name: 'MarketingManagingContent',
          },
          {
            path: 'new_release_banner/new/',
            name: 'CreateNewFeatureBanner',
            component: MarketingManagingContentAddEdit,
          },
          {
            path: 'new_release_banner/:bannerId/:mode/',
            name: 'EditViewNewFeatureBanner',
            component: MarketingManagingContentAddEdit,
            props: (route) => ({
              mode: route.params.mode,
              bannerId: parseInt(route.params.bannerId, 10) || null,
            }),
          },
        ],
      },
      {
        path: 'campaign_url/',
        component: CampaignUrl,
      },
      {
        path: 'campaign_url/view/new/',
        component: CampaignUrlCreateEdit,
      },
      {
        path: 'campaign_url/view/:campaignKey/',
        component: CampaignUrlCreateEdit,
      },
      {
        path: 'coupons_config/',
        component: CouponsConfig,
      },
      {
        path: 'webinars/',
        meta: {
          title: 'Webinars',
        },
        component: Webinars,
        children: [
          {
            path: '',
            name: 'MarketingWebinars',
            component: MarketingWebinars,
          },
          {
            path: 'new/',
            name: 'CreateWebinar',
            component: WebinarForm,
          },
          {
            path: ':webinarId/edit/',
            name: 'EditWebinar',
            component: WebinarForm,
            props: (route) => ({
              mode: 'edit',
              webinarId: parseInt(route.params.webinarId, 10) || null,
            }),
          },
          {
            path: ':webinarId/report/',
            name: 'WebinarReport',
            component: WebinarReport,
            props: (route) => ({
              webinarId: parseInt(route.params.webinarId, 10) || null,
            }),
          },
        ],
      },
      {
        path: 'partner_cards/',
        component: PartnerCards,
        name: 'PartnerCards',
      },
      {
        path: 'sinoa_partners/',
        component: SinoaPartners,
        name: 'SinoaPartners',
      },
    ],
  },
];

export default routes;
